let ShowHideRating = (function () {

    function createTimeline(instance) {
        let headlineSecond = instance._parent.querySelector('.headline.comments-title');
        let overlay = instance._target;
        let form = instance._parent.querySelector('.commentForm');
        let timeline = gsap.timeline({ paused: true });

        timeline
            .to(headlineSecond.querySelector('.first'), { opacity: 0, x: 500, duration: 1 })
            .to(headlineSecond.querySelector('.second span'), { opacity: 0, x: -500, duration: 1 }, "<")
            .to(overlay, { autoAlpha: 1, duration: .5 }, "-=.5")
            .from(overlay.querySelector('.close'), { opacity: 0, y: -100, duration: 1 })
            .from(form, { opacity: 0, y: 100, duration: 1 }, "<");
        ;

        return timeline;
    }

    function createOpenTimeline(instance) {
        let form = instance._parent.querySelector('.commentForm');
        let openTimeline = gsap.timeline({ paused: true });

        openTimeline.from(form, { opacity: 0, y: 100, duration: 1 });

        return openTimeline;
    }

    function show (instance) {
        instance._timeline.restart();
        instance._timeline.eventCallback("onComplete", function () {
            document.body.classList.add('overlay-is-visible');
            instance._target.classList.add('visible');
            instance._visible = true;

            //instance._openTimeline.restart();
        });
    }

    function hide (instance) {
        document.body.classList.remove('overlay-is-visible');
        instance._target.classList.remove('visible');
        instance._visible = false;

        instance._timeline.reverse();
    }

    function toggleListener (triggers, close, instance) {

        function toggle () {
            if( !instance._visible ) {
                show(instance);
            } else{
                hide(instance);
            }
        }

        triggers.forEach(function(btn) {
            btn.addEventListener('click', toggle);
        });

        close.addEventListener('click', toggle);

        return toggle;

    }

    function backgroundListener (instance) {
        instance._target.addEventListener('click', function(e) {
            if( !e.target.closest('.inner') ) {
                hide(instance);
            }
        });
    }

    function Constructor (element, parent) {

        // get the triggers
        let triggers = document.querySelectorAll('button[data-overlay="' + element.dataset.overlay + '"]');

        // Create the close button
        let close = document.createElement('button');
        close.className = 'close';

        // prepend to overlay
        element.querySelector('.inner').prepend(close);

        // Create the event listener
        let tl = toggleListener(triggers, close, this);

        // Set properties
        Object.defineProperties(this, {
            _target: {value: element, writable: true},
            _parent: {value: parent},
            _triggers: {value: triggers},
            _close: {value: close},
            _toggleListener: {value: tl},
            _visible: {value: false, writable: true},
        });

        this._timeline = createTimeline(this);
        //this._openTimeline = createOpenTimeline(this);

        backgroundListener(this);
    }

    return Constructor;

})();
